import React from "react";
import { useUrl } from "@/context/SiteContext";
import ServicePage from "./ServicePage";

export default function AuditDESIPage() {
  const url = useUrl();
  return (
    <ServicePage
      backLabel="Audituri"
      backTo={url.dept("audituri")}
      number="03"
      eyebrow="Audit digitalizare"
      title={["Audit DESI", "pentru digitalizare."]}
      tagline="Evaluarea nivelului de digitalizare al întreprinderii prin indicii și metodologia Digital Economy and Society Index — condiție esențială pentru finanțare."
      intro={[
        "Companiile care doresc să acceseze fonduri pentru digitalizare știu că îndeplinirea criteriilor DESI este obligatorie pentru admiterea în programele europene de finanțare.",
        "Pentru aceasta este necesar un audit tehnic IT care evaluează nivelul de digitalizare al întreprinderii prin folosirea indicilor DESI, adaptați pentru mediul de afaceri. Auditul furnizează date obiective despre stadiul de pregătire digitală și demonstrează impactul potențial al investițiilor în tehnologie.",
        "Cheltuielile cu serviciile pentru auditare tehnică IT — DESI sunt eligibile în cadrul proiectului de digitalizare.",
      ]}
      stepsEyebrow="Etapele auditului"
      stepsTitle="Cinci axe de evaluare."
      steps={[
        {
          title: "Infrastructură",
          desc: "Analiza tehnologiei disponibile, a gradului de utilizare și a conexiunilor de internet.",
        },
        {
          title: "Competențe",
          desc: "Verificarea nivelului de pregătire digitală a angajaților — de la utilizare de bază la abilități avansate.",
        },
        {
          title: "Integrare",
          desc: "Modul în care compania folosește tehnologiile avansate și contribuția lor la eficiența activității.",
        },
        {
          title: "Prezență online",
          desc: "Evaluarea canalelor digitale pentru interacțiunea cu clienții și accesibilitatea serviciilor web.",
        },
        {
          title: "Securitate",
          desc: "Cum au fost implementate măsurile de securitate cibernetică în cadrul companiei.",
        },
      ]}
      criteriaEyebrow="Ghid tehnic"
      criteriaTitle="Cele 12 criterii DESI."
      criteria={[
        "Cel puțin 50% dintre angajați folosesc calculatoare cu acces la internet, în scopuri de afaceri.",
        "Compania utilizează un pachet software ERP pentru a partaja informații între zonele comerciale.",
        "Viteza maximă de download a celei mai rapide conexiuni la linie fixă este de cel puțin 30 Mb/s, menținută pe toată durata proiectului.",
        "Vânzările online reprezintă peste 1% din cifra de afaceri, iar vânzările B2C depășesc 10% din vânzările web.",
        "Compania utilizează IoT (Internet of Things).",
        "Compania folosește cel puțin o rețea socială.",
        "Întreprinderea utilizează CRM (Customer Relationship Management).",
        "Compania cumpără servicii cloud computing, sofisticate sau intermediare.",
        "În organizație este utilizată tehnologia IA (Inteligența Artificială).",
        "Întreprinderea achiziționează servicii de cloud computing utilizate pe internet.",
        "Vânzările prin comerț electronic sunt de cel puțin 1% din totalul vânzărilor (fără comenzile pe e-mail).",
        "Întreprinderea utilizează două sau mai multe rețele sociale.",
      ]}
    />
  );
}
